import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {Button, UploadIcon, Vertical, Horizontal} from '@taopix/taopix-design-system';
import {useTaopix} from '../Context/TaopixContext';
import UploadWarningTip from '../Tips/UploadWarningTip';
import {useUiState} from '../Context/UserInterface/UserInterfaceContext';
import {useAssetStats} from '../Context/Assets/AssetStatsContext';
import {CoreEvent} from '@taopix/taopix-core';

const ACTION_BLACK_LIST = [
  'AutoFlow',
  'AutoFill',
  'DeletePages',
  'AddPages',
  'ApplyToAll',
  'SmartDesign',
];

const UploadProgressButton = () => {
  const app = useTaopix();
  const ui = useUiState();
  const {
    state: {hiresPercentage, totalPercentage, total},
  } = useAssetStats();
  const {t} = useTranslation();

  const [showButton, setShowButton] = useState(false);
  const [tipOpen, setTipOpen] = useState(false);

  useEffect(() => {
    if (showButton && hiresPercentage >= 100) {
      setShowButton(false);
      setTipOpen(false);
    }
  }, [hiresPercentage]);

  useEffect(() => {
    const token = app.core.subscribe(
      CoreEvent.PROJECT_SAVING,
      (
        msg: string,
        data: {showSaveOverlay: boolean; saving: boolean; caller: ''; isAutoSave: boolean}
      ) => {
        if (data.saving && !data.isAutoSave && !ACTION_BLACK_LIST.includes(data.caller)) {
          setShowButton(total > 0 && hiresPercentage < 100);
          setTipOpen(total > 0 && hiresPercentage < 100);
        }
      }
    );

    return () => {
      app.core.unsubscribe(token);
    };
  }, [hiresPercentage, total]);

  return (
    <>
      {showButton && (
        <Button
          label={`${totalPercentage}%`} // use the total upload totalUploadPercentage in the case of AI
          buttonStyle={'standard'}
          size={'small'}
          stacked
          startIcon={<UploadIcon />}
          id={'uploadProgressButton'}
          onClick={() => setTipOpen(current => !current)}
          className={'shrink-0 animate-pulse'}
        />
      )}

      <UploadWarningTip
        open={showButton && tipOpen}
        anchorId={ui.state.isSmallScreen ? 'editor-app-header' : 'uploadProgressButton'}
        arrow={ui.state.isSmallScreen ? undefined : 'auto'}
        anchorOrigin={{vertical: Vertical.Bottom, horizontal: Horizontal.Centre}}
        transformOrigin={{vertical: Vertical.Top, horizontal: Horizontal.Centre}}
        buttonFunction={() => setTipOpen(false)}
        title={t('*:str_MessageUploadPictures').replace('^0', String(totalPercentage))}
        message={t('helptips:str_MessageStillUploadingDontCloseBrowser')}
      />
    </>
  );
};

export default UploadProgressButton;
